/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { Folder, Label, Person, Public, ShoppingCart } from "@material-ui/icons";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import DescriptionIcon from "@material-ui/icons/Description";
import EcoIcon from '@material-ui/icons/Eco';
import GavelIcon from '@material-ui/icons/Gavel';
import LanguageIcon from "@material-ui/icons/Language";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import React from "react";
import SVG from "react-inlinesvg";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ExtensionIcon from '@material-ui/icons/Extension';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ComputerIcon from '@material-ui/icons/Computer';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import BuildIcon from '@material-ui/icons/Build';


export function AsideMenuList({ layoutProps }) {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li className="menu-section">
          <h4 className="menu-text">USERS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/admins",
                false
              )} ${getMenuItemActive("/edit-admin", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/admins">
                <span className="menu-icon">
                  <AssignmentIndIcon />
                </span>
                <span className="menu-text">Administrators</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/active-users",
                false
              )} ${getMenuItemActive("/edit-active-user", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/active-users">
                <span className="menu-icon">
                  <PeopleAltIcon />
                </span>
                <span className="menu-text">Active Users</span>
              </NavLink>
            </li>

          </>

        )}

        <li
          className={`menu-item ${getMenuItemActive(
            "/sellers",
            false
          )} ${getMenuItemActive("/edit-seller", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/sellers">
            <span className="menu-icon">
              <Label />
            </span>
            <span className="menu-text">Sellers</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/buyers",
            false
          )} ${getMenuItemActive("/edit-buyer", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/buyers">
            <span className="menu-icon">
              <ShoppingCart />
            </span>
            <span className="menu-text">Buyers</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/advisors",
            false
          )} ${getMenuItemActive("/edit-advisor", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/advisors">
            <span className="menu-icon">
              <SupervisorAccountIcon />
            </span>
            <span className="menu-text">Advisors</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/projects",
            false
          )} ${getMenuItemActive("/edit-project", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/projects">
            <span className="menu-icon">
              <Folder />
            </span>
            <span className="menu-text">Projects</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/deals",
            false
          )} ${getMenuItemActive("/watch-deal", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/deals">
            <span className="menu-icon">
              <SupervisedUserCircleIcon />
            </span>
            <span className="menu-text">Deals</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/advisorDeals",
            false
          )} ${getMenuItemActive("/watch-advisorDeals", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/advisorDeals">
            <span className="menu-icon">
              <SupervisedUserCircleIcon />
            </span>
            <span className="menu-text">Advisor Deals</span>
          </NavLink>
        </li>

        <li
          className={`menu-item ${getMenuItemActive(
            "/contacts",
            false
          )} ${getMenuItemActive("/watch-contact", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/contacts">
            <span className="menu-icon">
              <Person />
            </span>
            <span className="menu-text">Contacts</span>
          </NavLink>
        </li>

        <li className="menu-section">
          <h4 className="menu-text">WEB</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/partners",
                false
              )} ${getMenuItemActive("/edit-partner", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/partners">
                <span className="menu-icon">
                  <PeopleAltIcon />
                </span>
                <span className="menu-text">Partners</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/subscriptionPlans",
                false
              )} ${getMenuItemActive("/edit-subscriptionPlan", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/subscriptionPlans">
                <span className="menu-icon">
                  <AttachMoneyIcon />
                </span>
                <span className="menu-text">Subscription Plan</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/subscription-payments",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/subscription-payments">
                <span className="menu-icon">
                  <AttachMoneyIcon />
                </span>
                <span className="menu-text">Subscription Payments</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/features",
                false
              )} ${getMenuItemActive("/edit-feature", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/features">
                <span className="menu-icon">
                  <ExtensionIcon />
                </span>
                <span className="menu-text">Features plans</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/webProjects",
                false
              )} ${getMenuItemActive("/edit-webProject", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/webProjects">
                <span className="menu-icon">
                  <ComputerIcon />
                </span>
                <span className="menu-text">Web Projects</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/texts",
                false
              )} ${getMenuItemActive("/edit-text", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/texts">
                <span className="menu-icon">
                  <DescriptionIcon />
                </span>
                <span className="menu-text">Texts</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/categoryFaqs",
                false
              )} ${getMenuItemActive("/edit-categoryFaq", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/categoryFaqs">
                <span className="menu-icon">
                  <HelpOutlineIcon />
                </span>
                <span className="menu-text">Category FAQ</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/news",
                false
              )} ${getMenuItemActive("/edit-news", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/news">
                <span className="menu-icon">
                  <AssignmentIcon />
                </span>
                <span className="menu-text">News</span>
              </NavLink>
            </li>
          </>
        )}

        <li className="menu-section">
          <h4 className="menu-text">MISCELLANY</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/projectTitles",
                false
              )} ${getMenuItemActive("/edit-projectTitle", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/projectTitles">
                <span className="menu-icon">
                  <Folder />
                </span>
                <span className="menu-text">Project Titles</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/technologies",
                false
              )} ${getMenuItemActive("/edit-technology", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/technologies">
                <span className="menu-icon">
                  <EcoIcon />
                </span>
                <span className="menu-text">Technologies</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/developmentStatus",
                false
              )} ${getMenuItemActive("/edit-developmentStatus", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/developmentStatus">
                <span className="menu-icon">
                  <BusinessCenterIcon />
                </span>
                <span className="menu-text">Development Status</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/advisorServices",
                false
              )} ${getMenuItemActive("/edit-advisorService", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/advisorServices">
                <span className="menu-icon">
                  <GavelIcon />
                </span>
                <span className="menu-text">Advisors services</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/businessArea",
                false
              )} ${getMenuItemActive("/edit-businessArea", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/businessArea">
                <span className="menu-icon">
                  <GavelIcon />
                </span>
                <span className="menu-text">Business areas</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/manufacturers",
                false
              )} ${getMenuItemActive("/edit-manufacturer", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/manufacturers">
                <span className="menu-icon">
                  <BuildIcon />
                </span>
                <span className="menu-text">Manufacturers</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/languages",
                false
              )} ${getMenuItemActive("/edit-language", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/languages">
                <span className="menu-icon">
                  <LanguageIcon />
                </span>
                <span className="menu-text">Languages</span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/countries",
                false
              )} ${getMenuItemActive("/edit-country", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/countries">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Countries</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/provinces",
                false
              )} ${getMenuItemActive("/edit-province", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/provinces">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Provinces</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/cities",
                false
              )} ${getMenuItemActive("/edit-city", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/cities">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Cities</span>
              </NavLink>
            </li>
          </>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
